export default "__VITE_ASSET__CSQiNg8E__"